'use client';
import React from 'react';
import { useSearchParams } from 'next/navigation';
import { Logo, Skeleton } from '@design-system';
import { useCurrentApplicant } from '@apply/hooks/applicant/queries/use-current-applicant';

export function ApplyLogo(): React.JSX.Element {
  const searchParams = useSearchParams();
  const pathId = searchParams.get('pathId');
  const { applicant, isLoading } = useCurrentApplicant();

  const campusCity = applicant?.activePaths?.find((path) => path.id === pathId)?.campus?.city;

  return (
    <div className="flex h-full w-full">
      <Logo campus={campusCity} />
      {isLoading ? <Skeleton className="ms-xs mt-lg h-[1em] flex-1" /> : null}
    </div>
  );
}
